
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsor",
      function () {
        return require("private-next-pages/sponsor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsor"])
      });
    }
  